if (!customElements.get('product-gallery')) {
    customElements.define(
        'product-gallery',
        class ProductGallery extends HTMLElement {
            connectedCallback() {
                // show images for the initial variant on first paint
                this.updateVisibility(this.defaultVariantId());

                // keep the callback reference so we can remove it later
                this.onVariantChangeHandler = this.onVariantChange.bind(this);
                document.addEventListener('variant:change', this.onVariantChangeHandler);
            }

            disconnectedCallback() {
                document.removeEventListener('variant:change', this.onVariantChangeHandler);
            }

            /* ----------  private helpers ---------- */

            defaultVariantId() {
                return this.dataset.defaultVariantId || null;
            }

            sameSection(detail) {
                // Allows several product blocks to coexist on a page / in a modal
                return !detail?.sectionId || detail.sectionId === this.dataset.section;
            }

            onVariantChange(event) {
                const { variantId } = event.detail || {};
                if (!this.sameSection(event.detail)) return;           // ignore other products
                this.updateVisibility(variantId);
            }

            updateVisibility(variantId) {
                const variantImages = this.querySelectorAll('.js-show-variant-images');
                const hideProductImages = this.querySelector('.js-hide-product-images');

                /* 1.  Hide everything */
                hideProductImages?.classList.remove('flex');
                hideProductImages?.classList.add('hidden');

                variantImages.forEach((el) => {
                    el.classList.add('hidden');
                    el.classList.remove('flex');
                });

                /* 2.  Try to show the gallery that matches the variant */
                if (variantId) {
                    const target = this.querySelector(`[data-variant-id='${variantId}']`);
                    if (target) {
                        target.classList.add('flex');
                        target.classList.remove('hidden');
                        return;
                    }
                }

                /* 3.  Fallback → show default gallery */
                hideProductImages?.classList.add('flex');
                hideProductImages?.classList.remove('hidden');
            }
        }
    );
}



function zoomGallery() {
    const overlayContainer = document.querySelector(".overlay-large-images");
    const overlayImageContainer = document.querySelector(".overlay-large-image-container");
    const overlayImage = document.getElementById("overlayImage");
    // const overlaySpinner = document.querySelector(".overlay-spinner");
    const closeBtn = document.querySelector(".close_btn");
    const zoomBtns = document.querySelectorAll(".btn-overlay-large-images");

    zoomBtns.forEach((zoomBtn, index) => {
        zoomBtn.addEventListener("click", (event) => {
            event.preventDefault();
            showLargeOverlayImg(index);
            document.body.classList.add('gallery-open');
            overlayContainer.classList.remove('hidden');
        });
    });

    closeBtn.addEventListener("click", (event) => {
        event.preventDefault();
        hideLargeOverlayImg();
    });
    function showLargeOverlayImg(imgIndex) {
        overlayImage.onload = () => {
            // overlaySpinner.style.display = "none";
            document.body.classList.add('gallery-open');
            overlayContainer.classList.remove('hidden');
            centralizeScroller();
        };

        overlayImage.onerror = () => {
            console.error("Error loading image:", overlayImage.src);
            // overlaySpinner.style.display = "none";
        };

        const largeImgUrl = zoomBtns[imgIndex].getAttribute("data-image");
        overlayImage.src = largeImgUrl;

        // overlaySpinner.style.display = "block";
    }

    function hideLargeOverlayImg() {
        overlayContainer.classList.add('hidden');
        document.body.classList.remove('gallery-open');
    }

    function centralizeScroller() {
        // Calculate and set the scroll position for horizontal centralization
        overlayImageContainer.scrollLeft = (overlayImage.offsetWidth - overlayImageContainer.offsetWidth) / 2;
    }
}
zoomGallery();
document.addEventListener("shopify:section:load", function (event) {
    zoomGallery();
});